import { Message } from "element-ui";
import Auth from "@/utils/Auth"; // 验权
import WebSocketUtil from "@/utils/WebSocketUtil";
import HttpConnection from "@/utils/HttpConnection";
import router from "@/router/index";
import { manageEducation, manageStudy } from "@/router/MenuConfig";

export default {
    state: {
        menus: [
            {
                name: "首页",
                path: "/Index",
            },
            {
                name: "新闻中心",
                path: "/News",
            },
            {
                name: "精英采访",
                path: "/Interviews",
            },
            {
                name: "师资阵容",
                path: "/Teachers",
            },
            {
                name: "公开资源",
                path: "/OpenResource",
            },
            // {
            //     name: "帮助中心",
            //     path: "/HelpCenter/SystemConfig",
            // },
        ],
        userInfo: {
            avatar: "/group1/M00/00/01/wKhigGGcplSAYXyiAAAlfOf0el8242.png",
            age: 3,
            userId: null,
            sex: "1",
            userName: null,
            nickName: null,
            email: null,
            phonenumber: null,
            roleId: null, // 100教师，101学生，102游客
            roleKey: null,
            supplementFlag: false, // 学员（101）用户补充材料
        },
    },
    mutations: {
        setUserInfo(state, params) {
            state.userInfo = params;
        },
    },
    actions: {
        generationRouters({ state, commit }) {
            return new Promise(function (resolve, reject) {
                HttpConnection.get("getInfo")
                    .then(function (res) {
                        let _userInfo = {
                            avatar: res.user.avatar,
                            age: res.user.age,
                            userId: res.user.userId,
                            sex: res.user.sex,
                            userName: res.user.userName,
                            nickName: res.user.nickName,
                            email: res.user.email,
                            phonenumber: res.user.phonenumber,
                            roleId: res.user.roles[0].roleId,
                            roleKey: res.user.roles[0].roleKey,
                            supplementFlag: res.user.supplementFlag,
                            classerId: res.user.classerId,
                            classerName: res.user.classerName,
                            classerEndTime: res.user.classerEndTime, // 班级结束时间
                            classerStartTime: res.user.classerStartTime, // 开班开始时间
                        };
                        if (_userInfo.roleId == 100) {
                            // 教师
                            commit("setUserInfo", _userInfo);
                            let _menus = state.menus;
                            _menus.push({
                                name: "教学管理",
                                path: "/ManageEducation/TeacherSchedule",
                            });
                            router.addRoutes([manageEducation]);
                            WebSocketUtil.initWebsocket();
                            resolve(true);
                        } else if (_userInfo.roleId == 101) {
                            // 学生
                            commit("setUserInfo", _userInfo);
                            let _menus = state.menus;
                            _menus.push({
                                name: "我的课程",
                                path: "/ManageStudy/StudentSchedule",
                            });
                            router.addRoutes([manageStudy]);
                            WebSocketUtil.initWebsocket();
                            resolve(true);
                        } else if (_userInfo.roleId != null) {
                            // Message({
                            //     message:
                            //         "您不是教师用户或学员用户，禁止使用本系统",
                            //     type: "error",
                            //     duration: 5000,
                            // });
                            // setInterval(() => {
                            //     Auth.removeToken();
                            //     localStorage.clear();
                            // location.reload();
                            // reject(true);
                            // }, 5000);
                            // 非学生和教师用户
                            commit("setUserInfo", _userInfo);
                            WebSocketUtil.initWebsocket();
                            resolve(true);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        Auth.removeToken();
                        localStorage.clear();
                        location.reload();
                        Message.error(error.msg);
                        reject(false);
                    });
            });
        },
    },
};
